import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';

const EMPTY = { name:'', title:'', company:'', quote:'', rating:5, is_published:true };

export default function Testimonials() {
  const [items, setItems]   = useState([]);
  const [modal, setModal]   = useState(false);
  const [form, setForm]     = useState(EMPTY);
  const [editing, setEditing] = useState(null);
  const [saving, setSaving]   = useState(false);

  const load = useCallback(() => {
    axios.get('/api/testimonials').then(r => setItems(r.data));
  }, []);

  useEffect(() => { load(); }, [load]);

  const openNew  = () => { setForm(EMPTY); setEditing(null); setModal(true); };
  const openEdit = t => { setForm({ name:t.name, title:t.title, company:t.company, quote:t.quote, rating:t.rating, is_published:t.is_published }); setEditing(t.id); setModal(true); };
  const closeModal = () => setModal(false);

  const save = async e => {
    e.preventDefault(); setSaving(true);
    try {
      if (editing) { await axios.put(`/api/testimonials/${editing}`, form); toast.success('Updated'); }
      else         { await axios.post('/api/testimonials', form); toast.success('Created'); }
      closeModal(); load();
    } catch (err) { toast.error(err.response?.data?.error || 'Save failed'); }
    finally { setSaving(false); }
  };

  const remove = async id => {
    if (!window.confirm('Delete this testimonial?')) return;
    try { await axios.delete(`/api/testimonials/${id}`); toast.success('Deleted'); load(); }
    catch { toast.error('Failed'); }
  };

  return (
    <div>
      <div className="page-header">
        <div><h1>Testimonials</h1><p>Manage customer reviews shown on the website</p></div>
        <button className="btn btn--primary" onClick={openNew}>+ Add Testimonial</button>
      </div>

      <div className="card">
        <div className="table-wrap">
          <table>
            <thead><tr><th>Name</th><th>Company</th><th>Rating</th><th>Published</th><th>Quote</th><th>Actions</th></tr></thead>
            <tbody>
              {items.map(t => (
                <tr key={t.id}>
                  <td><strong>{t.name}</strong><br /><small style={{ color:'var(--slate)' }}>{t.title}</small></td>
                  <td>{t.company}</td>
                  <td>{'★'.repeat(t.rating)}</td>
                  <td><span className={`badge badge--${t.is_published ? 'active' : 'inactive'}`}>{t.is_published ? 'Yes' : 'No'}</span></td>
                  <td style={{ maxWidth:240, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', color:'var(--gray)', fontStyle:'italic' }}>"{t.quote}"</td>
                  <td style={{ display:'flex', gap:8 }}>
                    <button className="btn btn--ghost btn--sm" onClick={() => openEdit(t)}>Edit</button>
                    <button className="btn btn--danger btn--sm" onClick={() => remove(t.id)}>Delete</button>
                  </td>
                </tr>
              ))}
              {items.length === 0 && <tr><td colSpan={6}><div className="empty-state"><div className="icon">⭐</div>No testimonials yet</div></td></tr>}
            </tbody>
          </table>
        </div>
      </div>

      {modal && (
        <div className="modal-backdrop" onClick={e => e.target === e.currentTarget && closeModal()}>
          <div className="modal">
            <h2>{editing ? 'Edit Testimonial' : 'Add Testimonial'}</h2>
            <form onSubmit={save}>
              {[['name','Name','text',true],['title','Job Title','text',false],['company','Company','text',true]].map(([f,l,t,r]) => (
                <div className="form-field" key={f}>
                  <label>{l}{r && ' *'}</label>
                  <input className="form-control" type={t} required={r} value={form[f]}
                    onChange={e => setForm({ ...form, [f]: e.target.value })} />
                </div>
              ))}
              <div className="form-field">
                <label>Quote *</label>
                <textarea className="form-control" rows={4} required value={form.quote}
                  onChange={e => setForm({ ...form, quote: e.target.value })} style={{ resize:'vertical' }} />
              </div>
              <div className="form-field">
                <label>Rating</label>
                <select className="form-control" value={form.rating} onChange={e => setForm({ ...form, rating: Number(e.target.value) })}>
                  {[5,4,3,2,1].map(r => <option key={r} value={r}>{r} ★</option>)}
                </select>
              </div>
              <div className="form-field" style={{ display:'flex', alignItems:'center', gap:10 }}>
                <input type="checkbox" id="pub" checked={form.is_published}
                  onChange={e => setForm({ ...form, is_published: e.target.checked })} />
                <label htmlFor="pub" style={{ margin:0, textTransform:'none', letterSpacing:0, fontSize:13, color:'var(--dark)', fontWeight:500 }}>Published on website</label>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn--ghost" onClick={closeModal}>Cancel</button>
                <button type="submit" className="btn btn--primary" disabled={saving}>{saving ? 'Saving…' : 'Save'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
